// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__306Dw","footer":"styles_footer__2NsIY","passCodeTooltip":"styles_passCodeTooltip__3ybPY"};